import React, { useRef } from 'react';

function ADMETPredictionForm({ onSubmit }) {
  const fileRef = useRef();

  const handleSubmit = () => {
    const file = fileRef.current.files[0];
    if (!file) return alert("请选择一个化合物文件（.smi/.sdf）");

    const form = new FormData();
    form.append('molFile', file);
    onSubmit('ADMET分析', form, 'admet');
  };

  return (
    <div className="flex flex-col h-full">
      <input
        type="file"
        accept=".smi,.sdf,.txt"
        ref={fileRef}
        className="form-input"
      />
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">提交任务</button>
      </div>
    </div>
  );
}

export default ADMETPredictionForm;

